import React from "react";

const PhotoVaultSingleVaultItem = (props) => {
  ////// on click
  //// open to cover whole screen

  return (
    <div>
      <div className="photoVault-Vault-Container">
        <div className="photoVault-Vault-Button">{props.photoAlbumName}</div>{" "}
      </div>
    </div>
  );
};

export default PhotoVaultSingleVaultItem;
